import { render, staticRenderFns } from "./NavHistory.vue?vue&type=template&id=0b5f6ebf&scoped=true"
import script from "./NavHistory.vue?vue&type=script&lang=js"
export * from "./NavHistory.vue?vue&type=script&lang=js"
import style0 from "./NavHistory.vue?vue&type=style&index=0&id=0b5f6ebf&prod&lang=less&scoped=true"
import style1 from "./NavHistory.vue?vue&type=style&index=1&id=0b5f6ebf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f6ebf",
  null
  
)

export default component.exports